module.exports = __webpack_public_path__ + "img/loading_3.49064aeb.gif";